import { useParams } from 'react-router-dom'

import { RouteParams } from '@/routes/routes'

export default function useOrganisationId() {
  const { organisationId } = useParams<RouteParams['ORGANISATION']>()
  return organisationId
}
